/// <amd-module name="Artifacts/Root/types/IPackage" />
import { Protocol } from "Artifacts/Root/Constants";

/**
 * Package general metadata.
 */
export interface IPackage {
  /**
   * ID of the package.
   */
  id: string;
  /**
   * The display name of the package.
   */
  name: string;
  /**
   * Package protocol.
   */
  protocol: Protocol;
}
